<div class="layout-footer flex justify-content-end align-items-center p-4 shadow-3">
  <div class="flex">CarbonBlock</div>
</div>
